/*
 * ==============================================================================
 *
 * Copyright (c) 2023. Koninklijke Philips Electronics N.V.
 *
 * All rights are reserved. Reproduction in whole or in part is prohibited without the prior written consent of the copyright holder.
 *
 * ==============================================================================
 */

import React from "react";
import Skeleton from "react-loading-skeleton";

const Loading = ({ count = 5, hasHeader = true, style = {}, lineHeight }) => {
  return (
    <div style={{ width: "100%", padding: 10, ...style }}>
      {hasHeader ? (
        <div style={{ display: "flex", flex: 1, flexDirection: "row", justifyContent: "space-between" }}>
          <h1 style={{ width: Math.floor(Math.random() * 200) + 200, marginTop: 0 }}>
            <Skeleton />
          </h1>
          <h1 style={{ width: 100, marginTop: 0 }}>
            <Skeleton />
          </h1>
        </div>
      ) : null}
      <div style={{ display: "flex", flex: 1, flexDirection: "row", lineHeight: lineHeight || 1.5 }}>
        <h2 style={{ paddingRight: 10, width: 50, margin: 0 }}>
          <Skeleton count={count} />
        </h2>
        <h2 style={{ width: "100%", margin: 0 }}>
          <Skeleton count={count} />
        </h2>
      </div>
    </div>
  );
};

export default Loading;
